(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["engineering-calculators"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-engineering-calculators]:not([data-engineering-ready])').forEach((root) => {
      root.dataset.engineeringReady = 'true';
      const i18n = JSON.parse(root.querySelector('[data-engineering-i18n]').textContent);
      const entityDecoder = document.createElement('textarea');
      Object.keys(i18n).forEach((key) => {
        if (typeof i18n[key] !== 'string') return;
        entityDecoder.innerHTML = i18n[key];
        i18n[key] = entityDecoder.value;
      });
      const unitSelect = root.querySelector('[data-unit-system]');
      const tabs = [...root.querySelectorAll('[data-calculator-tab]')];
      const forms = [...root.querySelectorAll('[data-calculator-form]')];
      const resultEmpty = root.querySelector('[data-result-empty]');
      const resultContent = root.querySelector('[data-result-content]');
      const resultTitle = root.querySelector('[data-result-title]');
      const resultLevel = root.querySelector('[data-result-level]');
      const resultMetrics = root.querySelector('[data-result-metrics]');
      const resultNotes = root.querySelector('[data-result-notes]');
      const productMatches = root.querySelector('[data-product-matches]');
      const productMatchCount = root.querySelector('[data-product-match-count]');
      const productMatchList = root.querySelector('[data-product-match-list]');
      const noProductMatch = root.querySelector('[data-no-product-match]');
      const productTemplates = [...root.querySelectorAll('[data-product-template]')];
      const openMachineCompare = root.querySelector('[data-open-machine-compare]');
      const resultRfq = root.querySelector('[data-result-rfq]');
      const saveResultButton = root.querySelector('[data-save-result]');
      const copyResultButton = root.querySelector('[data-copy-result]');
      const shortlistTray = root.querySelector('[data-shortlist-tray]');
      const shortlistCount = root.querySelector('[data-shortlist-count]');
      const shortlistDialog = root.querySelector('[data-shortlist-dialog]');
      const shortlistContent = root.querySelector('[data-shortlist-content]');
      const shortlistRfq = root.querySelector('[data-shortlist-rfq]');
      const shortlistKey = 'umprotech-engineering-shortlist-v1';
      const machineCompareKey = 'umprotech-machine-compare-v1';
      let unitSystem = 'imperial';
      let activeType = 'laser';
      let currentResult = null;
      let shortlist = [];

      const number = (form, name) => Number(form.elements[name].value);
      const inToMm = (value) => value * 25.4;
      const mmToIn = (value) => value / 25.4;
      const ftToM = (value) => value * 0.3048;
      const mToFt = (value) => value / 0.3048;
      const psiToBar = (value) => value / 14.5038;
      const barToPsi = (value) => value * 14.5038;
      const lbToKg = (value) => value * 0.453592;
      const kgToLb = (value) => value / 0.453592;
      const cfmToM3Min = (value) => value * 0.0283168;
      const m3MinToCfm = (value) => value / 0.0283168;
      const round = (value, digits = 1) => Number(value.toFixed(digits));
      const displayLength = (mm) => unitSystem === 'imperial' ? `${round(mmToIn(mm), 2)} ${i18n.in}` : `${round(mm, 1)} ${i18n.mm}`;
      const displayLong = (meters) => unitSystem === 'imperial' ? `${round(mToFt(meters), 1)} ${i18n.ft}` : `${round(meters, 1)} ${i18n.m}`;
      const displayPressure = (psi) => unitSystem === 'imperial' ? `${round(psi, 0)} ${i18n.psi}` : `${round(psiToBar(psi), 1)} ${i18n.bar}`;
      const displayFlow = (cfm) => unitSystem === 'imperial' ? `${round(cfm, 0)} ${i18n.cfm}` : `${round(cfmToM3Min(cfm), 2)} ${i18n.m3min}`;
      const displayTons = (tons) => unitSystem === 'imperial' ? `${round(tons, 1)} ${i18n.usTons}` : `${round(tons * 0.907185, 1)} ${i18n.metricTonnes}`;
      const activeForm = () => forms.find((form) => form.dataset.calculatorForm === activeType);

      const setToast = (button, message) => {
        const previous = button.textContent;
        button.textContent = message;
        setTimeout(() => {
          button.textContent = previous;
        }, 1800);
      };

      const updateUnitLabels = () => {
        const labels = unitSystem === 'imperial'
          ? { length: i18n.in, long: i18n.ft, pressure: i18n.psi, weight: i18n.lb, flow: i18n.cfm }
          : { length: i18n.mm, long: i18n.m, pressure: i18n.bar, weight: i18n.kg, flow: i18n.m3min };
        root.querySelectorAll('[data-unit-label]').forEach((label) => {
          label.textContent = labels[label.dataset.unitLabel];
        });
      };

      const convertFields = (from, to) => {
        if (from === to) return;
        root.querySelectorAll('[data-convert]').forEach((field) => {
          const value = Number(field.value);
          if (!Number.isFinite(value)) return;
          const kind = field.dataset.convert;
          let next = value;
          if (from === 'imperial' && to === 'metric') {
            if (kind === 'length') next = inToMm(value);
            if (kind === 'long') next = ftToM(value);
            if (kind === 'pressure') next = psiToBar(value);
            if (kind === 'weight') next = lbToKg(value);
            if (kind === 'flow') next = cfmToM3Min(value);
          } else {
            if (kind === 'length') next = mmToIn(value);
            if (kind === 'long') next = mToFt(value);
            if (kind === 'pressure') next = barToPsi(value);
            if (kind === 'weight') next = kgToLb(value);
            if (kind === 'flow') next = m3MinToCfm(value);
          }
          field.value = String(round(next, kind === 'weight' ? 0 : 2));
        });
      };

      const metricValue = (form, name, kind) => {
        const value = number(form, name);
        if (unitSystem === 'metric') return value;
        if (kind === 'length') return inToMm(value);
        if (kind === 'long') return ftToM(value);
        if (kind === 'weight') return lbToKg(value);
        return value;
      };

      const imperialValue = (form, name, kind) => {
        const value = number(form, name);
        if (unitSystem === 'imperial') return value;
        if (kind === 'length') return mmToIn(value);
        if (kind === 'long') return mToFt(value);
        if (kind === 'pressure') return barToPsi(value);
        if (kind === 'weight') return kgToLb(value);
        if (kind === 'flow') return m3MinToCfm(value);
        return value;
      };

      const getMachineComparison = () => {
        try {
          return JSON.parse(sessionStorage.getItem(machineCompareKey) || '[]').filter((handle) => typeof handle === 'string').slice(0, 3);
        } catch {
          return [];
        }
      };

      const saveMachineComparison = (handles) => {
        try {
          sessionStorage.setItem(machineCompareKey, JSON.stringify(handles.slice(0, 3)));
        } catch {
        }
      };

      const renderProductMatches = (data) => {
        productMatchList.replaceChildren();
        if (!data.matchKind || !Number.isFinite(data.matchRating)) {
          productMatches.hidden = true;
          return [];
        }
        productMatches.hidden = false;
        const candidates = productTemplates
          .filter((template) => template.dataset.kind === data.matchKind)
          .map((template) => ({ template, rating: Number(template.dataset.rating) }))
          .filter((item) => item.rating >= data.matchRating)
          .sort((a, b) => a.rating - b.rating)
          .slice(0, 3);
        productMatchCount.textContent = `${candidates.length} ${i18n.matchCount}`;
        noProductMatch.hidden = candidates.length > 0;
        const matched = [];
        candidates.forEach(({ template, rating }) => {
          const fragment = template.content.cloneNode(true);
          const button = fragment.querySelector('[data-add-machine-compare]');
          const handle = template.dataset.handle;
          const title = template.dataset.title;
          const updateButton = () => {
            const selected = getMachineComparison().includes(handle);
            button.setAttribute('aria-pressed', String(selected));
            button.textContent = selected ? i18n.addedMachine : i18n.addMachine;
          };
          button.addEventListener('click', () => {
            let selected = getMachineComparison();
            if (selected.includes(handle)) {
              selected = selected.filter((item) => item !== handle);
            } else if (selected.length < 3) {
              selected.push(handle);
            } else {
              setToast(button, i18n.machineLimit);
              return;
            }
            saveMachineComparison(selected);
            productMatchList.querySelectorAll('[data-add-machine-compare]').forEach((control) => {
              const parent = control.closest('[data-machine-card]');
              const on = selected.includes(parent.dataset.handle);
              control.setAttribute('aria-pressed', String(on));
              control.textContent = on ? i18n.addedMachine : i18n.addMachine;
            });
          });
          updateButton();
          productMatchList.append(fragment);
          matched.push({ handle, title, rating });
        });
        return matched;
      };

      const renderResult = (data) => {
        currentResult = data;
        resultEmpty.hidden = true;
        resultContent.hidden = false;
        resultTitle.textContent = data.title;
        resultLevel.textContent = data.level;
        resultMetrics.replaceChildren();
        data.metrics.forEach((metric) => {
          const item = document.createElement('div');
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = metric.label;
          dd.textContent = metric.value;
          item.append(dt, dd);
          resultMetrics.append(item);
        });
        resultNotes.replaceChildren();
        data.notes.forEach((note) => {
          const li = document.createElement('li');
          li.textContent = note;
          resultNotes.append(li);
        });
        const matchedProducts = renderProductMatches(data);
        data.matchedProducts = matchedProducts;
        const params = new URLSearchParams({
          route: 'machine_quote',
          source: 'engineering-calculators',
          calculator: data.type,
          configuration: data.title,
          capacity: data.summary,
          source_path: location.pathname
        });
        if (matchedProducts.length) {
          params.set('machine', matchedProducts[0].title);
          params.set('comparison', matchedProducts.map((item) => item.title).join(' | '));
        }
        resultRfq.href = `${root.dataset.rfqUrl}?${params.toString()}`;
        resultContent.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      const calculateLaser = (form) => {
        const material = form.elements.material.value;
        const thickness = metricValue(form, 'thickness', 'length');
        const demand = form.elements.demand.value;
        const gas = form.elements.gas.value;
        const classes = [2, 3, 6, 12, 20];
        const tables = {
          mild: [6, 10, 16, 26, 40],
          stainless: [2, 5, 10, 16, 25],
          aluminum: [3, 6, 10, 16, 25],
          brass: [2, 4, 6, 10, 16]
        };
        const limits = tables[material];
        const minimumIndex = limits.findIndex((limit) => thickness <= limit);
        if (minimumIndex === -1) {
          renderResult({
            type: 'laser',
            title: i18n.applicationReview,
            level: i18n.applicationReview,
            summary: `${displayLength(thickness)} material`,
            metrics: [
              { label: i18n.minimum, value: i18n.applicationReview },
              { label: i18n.recommended, value: i18n.applicationReview }
            ],
            notes: [i18n.sampleCut, i18n.laserNearLimit]
          });
          return;
        }
        const nearLimit = thickness >= limits[minimumIndex] * 0.82;
        const demandStep = demand === 'production' ? 1 : 0;
        const recommendedIndex = Math.min(minimumIndex + demandStep + (nearLimit ? 1 : 0), classes.length - 1);
        const reserveIndex = Math.min(recommendedIndex + 1, classes.length - 1);
        const notes = [i18n.sampleCut];
        if (nearLimit) notes.push(i18n.laserNearLimit);
        if (gas === 'oxygen') notes.push(i18n.oxygenNote);
        if (gas === 'nitrogen') notes.push(i18n.nitrogenNote);
        if (gas === 'air') notes.push(i18n.airNote);
        const title = `${classes[recommendedIndex]} ${i18n.kwClass}`;
        renderResult({
          type: 'laser',
          matchKind: 'laser',
          matchRating: classes[recommendedIndex],
          title,
          level: i18n.laserTitle,
          summary: `${displayLength(thickness)} • ${material} • ${demand}`,
          metrics: [
            { label: i18n.minimum, value: `${classes[minimumIndex]} ${i18n.kwClass}` },
            { label: i18n.recommended, value: title },
            { label: i18n.reserve, value: `${classes[reserveIndex]} ${i18n.kwClass}` },
            { label: i18n.designPressure, value: gas === 'air' ? displayPressure(232) : gas }
          ],
          notes
        });
      };

      const calculateBrake = (form) => {
        const thicknessIn = imperialValue(form, 'thickness', 'length');
        const bendLengthFt = imperialValue(form, 'bendLength', 'long');
        const dieIn = imperialValue(form, 'dieOpening', 'length');
        const materialFactor = number(form, 'material');
        const methodFactor = number(form, 'method');
        const tons = (575 * thicknessIn * thicknessIn / dieIn / 12) * (bendLengthFt * 12) * materialFactor * methodFactor;
        const reserve = tons * 1.2;
        const perFoot = tons / bendLengthFt;
        const machineClasses = [30, 50, 63, 80, 100, 125, 160, 175, 220, 250, 320, 400];
        const machineClass = machineClasses.find((value) => value >= reserve);
        const dieRatio = dieIn / thicknessIn;
        const notes = [i18n.toolingCheck];
        if (dieRatio < 6 || dieRatio > 12) notes.push(i18n.dieRatio);
        if (methodFactor > 1) notes.push(i18n.formingMethod);
        const title = machineClass ? displayTons(machineClass) : i18n.applicationReview;
        renderResult({
          type: 'brake',
          matchKind: 'brake',
          matchRating: machineClass,
          title,
          level: i18n.brakeTitle,
          summary: `${displayTons(tons)} load • ${displayLong(unitSystem === 'imperial' ? ftToM(bendLengthFt) : number(form, 'bendLength'))} bend`,
          metrics: [
            { label: i18n.estimatedLoad, value: displayTons(tons) },
            { label: i18n.loadReserve, value: displayTons(reserve) },
            { label: i18n.machineClass, value: title },
            { label: i18n.tonnagePerFoot, value: `${displayTons(perFoot)}/${i18n.ft}` }
          ],
          notes
        });
      };

      const calculateTube = (form) => {
        const profile = form.elements.profile.value;
        const width = metricValue(form, 'width', 'length');
        const height = profile === 'square' ? width : metricValue(form, 'height', 'length');
        const stockMeters = metricValue(form, 'stockLength', 'long');
        const envelope = profile === 'round' ? width : Math.hypot(width, height);
        let clearanceFactor = profile === 'round' ? 1.05 : 1.1;
        if (form.elements.bevel.checked) clearanceFactor += 0.05;
        const required = envelope * clearanceFactor;
        const chuckClasses = [160, 240, 350, 400, 500];
        const chuck = chuckClasses.find((value) => value >= required);
        const stockFeet = mToFt(stockMeters);
        const lengthClass = stockFeet <= 20 ? 20 : stockFeet <= 24 ? 24 : stockFeet <= 40 ? 40 : null;
        const chuckLabel = chuck ? `${round(mmToIn(chuck), 1)} ${i18n.in} / ${chuck} ${i18n.mm}` : i18n.applicationReview;
        const notes = [i18n.tubeGeometry, i18n.tubeJaws];
        if (form.elements.bevel.checked) notes.push(i18n.tubeBevel);
        renderResult({
          type: 'tube',
          title: chuck ? `${round(mmToIn(chuck), 1)} ${i18n.in} ${i18n.chuckClass}` : i18n.applicationReview,
          level: i18n.tubeTitle,
          summary: `${profile} • ${displayLength(width)} × ${displayLength(height)} • ${displayLong(stockMeters)}`,
          metrics: [
            { label: i18n.envelope, value: displayLength(envelope) },
            { label: i18n.minimum, value: displayLength(required) },
            { label: i18n.chuckClass, value: chuckLabel },
            { label: i18n.stockClass, value: lengthClass ? `${lengthClass} ${i18n.ft}` : i18n.applicationReview }
          ],
          notes
        });
      };

      const calculateAir = (form) => {
        const application = form.elements.application.value;
        const pressurePsi = imperialValue(form, 'pressure', 'pressure');
        const additionalCfm = imperialValue(form, 'additional', 'flow');
        const duty = number(form, 'duty') / 100;
        let nozzleCfm = 0;
        if (application === 'laser') {
          const nozzleMm = metricValue(form, 'nozzle', 'length');
          const area = Math.PI * Math.pow(nozzleMm / 2000, 2);
          const absolutePa = (pressurePsi + 14.7) * 6894.76;
          const massFlow = 0.82 * area * absolutePa * Math.sqrt(1.4 / (287 * 293.15)) * Math.pow(2 / 2.4, 2.4 / 0.8);
          nozzleCfm = massFlow / 1.204 * 2118.88 * number(form, 'nozzles');
        }
        const peak = nozzleCfm + additionalCfm;
        const design = peak * 1.25;
        const packages = [
          [45, 15],
          [65, 20],
          [95, 30],
          [125, 40],
          [160, 50]
        ];
        const packageClass = packages.find(([limit]) => design <= limit);
        const title = packageClass ? `${packageClass[1]} ${i18n.hpClass}` : i18n.customPackage;
        const notes = [i18n.verifyFad, i18n.receiverNote];
        if (application === 'laser') notes.unshift(i18n.airQuality);
        renderResult({
          type: 'air',
          title,
          level: i18n.airTitle,
          summary: `${displayFlow(design)} at ${displayPressure(pressurePsi + 15)}`,
          metrics: [
            { label: i18n.peakFlow, value: displayFlow(peak) },
            { label: i18n.designFlow, value: displayFlow(design) },
            { label: i18n.designPressure, value: displayPressure(pressurePsi + 15) },
            { label: i18n.packageClass, value: `${title} • ${displayFlow(peak * duty)} avg.` }
          ],
          notes
        });
      };

      const calculateSite = (form) => {
        const type = form.elements.machineType.value;
        const supplyVoltage = number(form, 'supplyVoltage');
        const supplyPhase = number(form, 'supplyPhase');
        const serviceAmps = number(form, 'serviceAmps');
        const requiredVoltage = number(form, 'requiredVoltage');
        const requiredPhase = number(form, 'requiredPhase');
        const machineLoad = number(form, 'machineLoad');
        const supplyKva = (supplyPhase === 3 ? Math.sqrt(3) : 1) * supplyVoltage * serviceAmps / 1000;
        const requiredKva = machineLoad / 0.85 * 1.25;
        const doorWidthMm = metricValue(form, 'doorWidth', 'length');
        const shippingWidthMm = metricValue(form, 'shippingWidth', 'length');
        const roomWidthM = metricValue(form, 'roomWidth', 'long');
        const roomLengthM = metricValue(form, 'roomLength', 'long');
        const machineWidthM = metricValue(form, 'machineWidth', 'long');
        const machineLengthM = metricValue(form, 'machineLength', 'long');
        const weightLb = imperialValue(form, 'weight', 'weight');
        const forkliftLb = imperialValue(form, 'forklift', 'weight');
        const checks = [];
        if (supplyPhase !== requiredPhase) {
          checks.push({ status: 'action', text: i18n.phaseMismatch });
        } else if (Math.abs(supplyVoltage - requiredVoltage) / requiredVoltage > 0.1) {
          checks.push({ status: 'review', text: i18n.voltageMismatch });
        } else {
          checks.push({ status: 'ready', text: i18n.powerReady });
        }
        checks.push(supplyKva >= requiredKva
          ? { status: 'ready', text: `${i18n.powerCapacity} ${round(supplyKva, 1)} kVA / ${round(requiredKva, 1)} kVA.` }
          : { status: 'action', text: `${i18n.powerCapacity} ${round(supplyKva, 1)} kVA / ${round(requiredKva, 1)} kVA.` });
        checks.push(doorWidthMm >= shippingWidthMm + 152
          ? { status: 'ready', text: i18n.doorReady }
          : { status: 'action', text: i18n.doorAction });
        checks.push(roomWidthM >= machineWidthM + 1.83 && roomLengthM >= machineLengthM + 2.74
          ? { status: 'ready', text: i18n.spaceReady }
          : { status: 'review', text: i18n.spaceAction });
        checks.push(forkliftLb >= weightLb * 1.25
          ? { status: 'ready', text: i18n.riggingReady }
          : { status: 'action', text: i18n.riggingAction });
        const needsExtraction = type === 'sheet' || type === 'tube';
        const needsAir = type === 'sheet' || type === 'tube' || type === 'brake';
        if (needsExtraction) {
          checks.push(form.elements.extraction.value === 'yes'
            ? { status: 'ready', text: i18n.extractionReady }
            : { status: 'action', text: i18n.extractionAction });
        }
        if (needsAir) {
          checks.push(form.elements.air.value === 'yes'
            ? { status: 'ready', text: i18n.airReady }
            : { status: 'action', text: i18n.airAction });
        }
        checks.push({ status: 'review', text: i18n.floorReview });
        checks.push({ status: 'review', text: i18n.electricianReview });
        const counts = checks.reduce((acc, check) => {
          acc[check.status] += 1;
          return acc;
        }, { ready: 0, review: 0, action: 0 });
        const title = counts.action ? i18n.siteAction : i18n.siteReady;
        renderResult({
          type: 'site',
          title,
          level: i18n.siteTitle,
          summary: `${counts.ready} ready • ${counts.review} review • ${counts.action} action`,
          metrics: [
            { label: i18n.readyChecks, value: String(counts.ready) },
            { label: i18n.reviewChecks, value: String(counts.review) },
            { label: i18n.actionChecks, value: String(counts.action) },
            { label: i18n.designPressure, value: `${round(requiredKva, 1)} kVA est.` }
          ],
          notes: checks.map((check) => `${i18n[check.status]}: ${check.text}`)
        });
      };

      const calculators = {
        laser: calculateLaser,
        brake: calculateBrake,
        tube: calculateTube,
        air: calculateAir,
        site: calculateSite
      };

      const showTab = (type, focus = false) => {
        activeType = type;
        tabs.forEach((tab) => {
          const selected = tab.dataset.calculatorTab === type;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        forms.forEach((form) => {
          form.hidden = form.dataset.calculatorForm !== type;
        });
        resultEmpty.hidden = false;
        resultContent.hidden = true;
        currentResult = null;
      };

      const loadShortlist = () => {
        try {
          shortlist = JSON.parse(localStorage.getItem(shortlistKey) || '[]').slice(0, 3);
        } catch {
          shortlist = [];
        }
        shortlistCount.textContent = String(shortlist.length);
        shortlistTray.hidden = shortlist.length === 0;
      };

      const saveShortlist = () => {
        localStorage.setItem(shortlistKey, JSON.stringify(shortlist));
        loadShortlist();
      };

      const renderShortlist = () => {
        shortlistContent.replaceChildren();
        if (!shortlist.length) {
          const empty = document.createElement('p');
          empty.textContent = i18n.emptyShortlist;
          shortlistContent.append(empty);
          return;
        }
        shortlist.forEach((item, index) => {
          const card = document.createElement('article');
          card.className = 'engineering-calculators__shortlist-card';
          const type = document.createElement('small');
          const heading = document.createElement('h3');
          const summary = document.createElement('p');
          const remove = document.createElement('button');
          type.textContent = item.type;
          heading.textContent = item.title;
          summary.textContent = item.summary;
          remove.type = 'button';
          remove.textContent = i18n.remove;
          remove.addEventListener('click', () => {
            shortlist.splice(index, 1);
            saveShortlist();
            renderShortlist();
          });
          card.append(type, heading, summary, remove);
          shortlistContent.append(card);
        });
        const params = new URLSearchParams({
          route: 'machine_quote',
          source: 'engineering-shortlist',
          comparison: shortlist.map((item) => `${item.type}: ${item.title} (${item.summary})`).join(' | '),
          source_path: location.pathname
        });
        shortlistRfq.href = `${root.dataset.rfqUrl}?${params.toString()}`;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const change = () => showTab(tab.dataset.calculatorTab);
          if (document.startViewTransition) document.startViewTransition(change);
          else change();
        });
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          showTab(tabs[next].dataset.calculatorTab, true);
        });
      });

      forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          calculators[form.dataset.calculatorForm](form);
        });
      });

      unitSelect.addEventListener('change', () => {
        const next = unitSelect.value;
        convertFields(unitSystem, next);
        unitSystem = next;
        updateUnitLabels();
        if (currentResult) calculators[activeType](activeForm());
      });

      const profileSelect = root.querySelector('[data-profile-select]');
      const heightField = root.querySelector('[data-height-field]');
      const widthLabel = root.querySelector('[data-width-label]');
      profileSelect.addEventListener('change', () => {
        const needsHeight = ['rectangle', 'structural'].includes(profileSelect.value);
        heightField.hidden = !needsHeight;
        heightField.querySelector('input').required = needsHeight;
        widthLabel.textContent = profileSelect.value === 'round' ? widthLabel.dataset.roundText : widthLabel.dataset.widthText;
      });

      const airApplication = root.querySelector('[data-air-application]');
      const nozzleFields = [...root.querySelectorAll('[data-nozzle-field]')];
      airApplication.addEventListener('change', () => {
        const laser = airApplication.value === 'laser';
        nozzleFields.forEach((field) => {
          field.hidden = !laser;
          field.querySelector('input').disabled = !laser;
        });
      });

      const dutyRange = root.querySelector('[data-duty-range]');
      const dutyOutput = root.querySelector('[data-duty-output]');
      dutyRange.addEventListener('input', () => {
        dutyOutput.textContent = `${dutyRange.value}%`;
      });

      saveResultButton.addEventListener('click', () => {
        if (!currentResult) return;
        if (shortlist.length >= 3) {
          setToast(saveResultButton, i18n.limitMessage);
          return;
        }
        shortlist.push({
          type: currentResult.type,
          title: currentResult.title,
          summary: currentResult.summary,
          savedAt: Date.now()
        });
        saveShortlist();
        setToast(saveResultButton, i18n.savedMessage);
      });

      copyResultButton.addEventListener('click', async () => {
        if (!currentResult) return;
        const text = [currentResult.title, currentResult.summary, ...currentResult.metrics.map((metric) => `${metric.label}: ${metric.value}`), ...currentResult.notes].join('\n');
        try {
          await navigator.clipboard.writeText(text);
          setToast(copyResultButton, i18n.copiedMessage);
        } catch {
          setToast(copyResultButton, i18n.copyFailed);
        }
      });

      root.querySelector('[data-shortlist-open]').addEventListener('click', () => {
        renderShortlist();
        shortlistDialog.showModal();
      });
      root.querySelector('[data-shortlist-close]').addEventListener('click', () => shortlistDialog.close());
      root.querySelector('[data-shortlist-clear]').addEventListener('click', () => {
        shortlist = [];
        saveShortlist();
        renderShortlist();
        shortlistDialog.close();
      });
      shortlistDialog.addEventListener('click', (event) => {
        if (event.target === shortlistDialog) shortlistDialog.close();
      });

      updateUnitLabels();
      loadShortlist();
      const compareUrl = new URL('/', location.origin);
      const previewThemeId = new URLSearchParams(location.search).get('preview_theme_id');
      compareUrl.searchParams.set('source', 'engineering-calculators');
      if (previewThemeId) compareUrl.searchParams.set('preview_theme_id', previewThemeId);
      compareUrl.hash = 'MachineMatch-machine_match';
      openMachineCompare.href = compareUrl.toString();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machine-match-engine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-machine-match]:not([data-machine-match-ready])').forEach((root) => {
      root.dataset.machineMatchReady = 'true';

      const form = root.querySelector('[data-match-form]');
      const family = root.querySelector('[data-match-family]');
      const demand = root.querySelector('[data-match-demand]');
      const power = root.querySelector('[data-match-power]');
      const sheetFields = root.querySelector('[data-match-sheet-fields]');
      const pressFields = root.querySelector('[data-match-press-fields]');
      const sheetSize = root.querySelector('[data-match-sheet-size]');
      const design = root.querySelector('[data-match-design]');
      const bendLength = root.querySelector('[data-match-bend-length]');
      const material = root.querySelector('[data-match-material]');
      const thickness = root.querySelector('[data-match-thickness]');
      const results = root.querySelector('[data-match-results]');
      const advisor = root.querySelector('[data-match-advisor]');
      const familyShortcuts = [...root.querySelectorAll('[data-match-family-shortcut]')];
      const cards = [...root.querySelectorAll('[data-match-card]')];
      const quoteLink = root.querySelector('[data-match-quote]');
      const tray = root.querySelector('[data-compare-tray]');
      const count = root.querySelector('[data-compare-count]');
      const names = root.querySelector('[data-compare-names]');
      const openCompare = root.querySelector('[data-compare-open]');
      const dialog = root.querySelector('[data-compare-dialog]');
      const compareContent = root.querySelector('[data-compare-content]');
      const compareQuote = root.querySelector('[data-compare-quote]');
      const matchStorage = 'umprotech-machine-match-v1';
      const compareStorage = 'umprotech-machine-compare-v1';
      let selected = [];

      const tagsFor = (card) => (card.dataset.tags || '').split('|').filter(Boolean);
      const findTag = (card, prefixes) => tagsFor(card).find((tag) => prefixes.some((prefix) => tag.startsWith(prefix))) || '';
      const pretty = (value) => {
        if (!value) return root.dataset.notSpecified;
        const formatted = value
          .replace(/^power-/, '')
          .replace(/^capacity-/, '')
          .replace(/^size-/, '')
          .replace(/^design-/, '')
          .replace(/^duty-/, '')
          .replace(/^control-/, '')
          .replace(/^voltage-/, '')
          .replace(/^axis-/, '')
          .replace(/^feature-/, '')
          .replaceAll('-', ' ')
          .replace(/(\d+)x(\d+)/gi, '$1×$2')
          .replace(/(\d+)kw\b/gi, '$1 kW')
          .replace(/(\d+)w\b/gi, '$1 W')
          .replace(/(\d+)ft\b/gi, '$1 ft')
          .replace(/\bcnc\b/gi, 'CNC')
          .replace(/^220 240v single phase$/i, '220–240 V single-phase');
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
      };
      const familyToRoute = {
        sheet_laser: 'fiber-laser-cutting-machines',
        press_brake: 'hydraulic-press-brakes',
        laser_welder: 'handheld-laser-welding-machines'
      };
      const specs = (card) => {
        const rating = findTag(card, ['power-', 'capacity-']);
        const format = findTag(card, ['size-']);
        const configuration = [
          findTag(card, ['design-', 'control-']),
          findTag(card, ['axis-', 'feature-exchange-table'])
        ].filter(Boolean).map(pretty).join(' • ') || root.dataset.notSpecified;
        return {
          family: card.dataset.familyName || root.dataset.notSpecified,
          rating: pretty(rating),
          format: pretty(format),
          configuration,
          duty: pretty(findTag(card, ['duty-'])),
          power: pretty(findTag(card, ['voltage-']))
        };
      };
      const scoreCard = (card) => {
        if (card.dataset.family !== family.value) return -1000;
        const tags = tagsFor(card);
        let score = 20;

        if (family.value === 'sheet_laser') {
          if (demand.value === 'compact' && tags.includes('power-2kw')) score += 8;
          if (demand.value === 'balanced' && tags.includes('power-6kw')) score += 8;
          if (demand.value === 'heavy' && tags.includes('power-12kw')) score += 8;
          if (sheetSize.value && tags.includes('size-' + sheetSize.value)) score += 7;
          if (design.value && tags.includes('design-' + design.value)) score += 5;
          if (power.value === 'single_phase' && tags.includes('voltage-220-240v-single-phase')) score += 12;
          if (power.value === 'single_phase' && !tags.includes('voltage-220-240v-single-phase')) score -= 5;
        }

        if (family.value === 'press_brake') {
          if (demand.value === 'compact' && tags.includes('capacity-50-ton')) score += 8;
          if (demand.value === 'balanced' && tags.includes('capacity-63-ton')) score += 8;
          if (demand.value === 'heavy' && tags.includes('capacity-160-ton')) score += 8;
          if (bendLength.value && tags.includes('size-' + bendLength.value)) score += 9;
        }

        if (family.value === 'laser_welder') {
          if (demand.value === 'compact' && tags.includes('power-1500w')) score += 8;
          if (demand.value === 'balanced' && tags.includes('power-2000w')) score += 8;
          if (demand.value === 'heavy' && tags.includes('power-3000w')) score += 8;
        }

        return score;
      };
      const quoteParams = (selection) => {
        const selectedCards = selection.length ? selection : cards.filter((card) => !card.hidden).slice(0, 3);
        const machineNames = selectedCards.map((card) => card.dataset.title);
        const params = new URLSearchParams();
        params.set('route', 'machine_quote');
        params.set('source', 'machine-match');
        params.set('source_path', location.pathname);
        if (family.value) params.set('family', familyToRoute[family.value] || family.value);
        if (machineNames[0]) params.set('machine', machineNames[0]);
        if (machineNames.length) params.set('comparison', machineNames.join(' | '));
        if (material.value.trim()) params.set('application', material.value.trim());
        if (thickness.value.trim()) params.set('capacity', thickness.value.trim());
        if (demand.value) params.set('demand', demand.value);
        if (power.value) params.set('power', power.value);
        if (family.value === 'sheet_laser' && sheetSize.value) params.set('working_size', sheetSize.value);
        if (family.value === 'sheet_laser' && design.value) params.set('design', design.value);
        if (family.value === 'press_brake' && bendLength.value) params.set('working_size', bendLength.value);
        return params;
      };
      const updateConditionalFields = () => {
        const isSheet = family.value === 'sheet_laser';
        const isPress = family.value === 'press_brake';
        sheetFields.hidden = !isSheet;
        sheetSize.disabled = !isSheet;
        design.disabled = !isSheet;
        pressFields.hidden = !isPress;
        bendLength.disabled = !isPress;
        familyShortcuts.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.matchFamilyShortcut === family.value));
        });
      };
      const invalidateResults = () => {
        if (!results.hidden) {
          results.hidden = true;
          advisor.hidden = false;
        }
      };
      const saveMatch = () => {
        try {
          sessionStorage.setItem(matchStorage, JSON.stringify({
            family: family.value,
            demand: demand.value,
            power: power.value,
            sheetSize: sheetSize.value,
            design: design.value,
            bendLength: bendLength.value,
            material: material.value,
            thickness: thickness.value
          }));
        } catch {
        }
      };
      const restoreMatch = () => {
        try {
          const state = JSON.parse(sessionStorage.getItem(matchStorage) || '{}');
          family.value = state.family || '';
          demand.value = state.demand || '';
          power.value = state.power || '';
          sheetSize.value = state.sheetSize || '';
          design.value = state.design || '';
          bendLength.value = state.bendLength || '';
          material.value = state.material || '';
          thickness.value = state.thickness || '';
        } catch {
        }
        updateConditionalFields();
      };
      const updateTray = () => {
        count.textContent = String(selected.length);
        names.textContent = selected.map((card) => card.dataset.title.replace(/^UmproTech\s+/i, '')).join(' • ');
        tray.hidden = selected.length === 0;
        cards.forEach((card) => {
          const on = selected.includes(card);
          const button = card.querySelector('[data-compare-add]');
          button.setAttribute('aria-pressed', String(on));
          button.textContent = on ? root.dataset.addedLabel : root.dataset.addLabel;
        });
        try {
          sessionStorage.setItem(compareStorage, JSON.stringify(selected.map((card) => card.dataset.handle)));
        } catch {
        }
      };
      const restoreCompare = () => {
        try {
          const handles = JSON.parse(sessionStorage.getItem(compareStorage) || '[]');
          selected = handles.map((handle) => cards.find((card) => card.dataset.handle === handle)).filter(Boolean).slice(0, 3);
        } catch {
          selected = [];
        }
        updateTray();
      };
      const renderComparison = () => {
        compareContent.replaceChildren();
        if (!selected.length) return;

        const table = document.createElement('table');
        table.className = 'machine-match__table';
        const thead = document.createElement('thead');
        const headRow = document.createElement('tr');
        headRow.append(document.createElement('th'));

        selected.forEach((card) => {
          const th = document.createElement('th');
          const link = document.createElement('a');
          link.href = card.dataset.url;
          link.textContent = card.dataset.title;
          th.append(link);
          headRow.append(th);
        });
        thead.append(headRow);
        table.append(thead);

        const rows = [
          [root.dataset.familyLabel, 'family'],
          [root.dataset.classLabel, 'rating'],
          [root.dataset.formatLabel, 'format'],
          [root.dataset.configurationLabel, 'configuration'],
          [root.dataset.dutyLabel, 'duty'],
          [root.dataset.powerLabel, 'power']
        ];
        const tbody = document.createElement('tbody');

        rows.forEach(([label, key]) => {
          const tr = document.createElement('tr');
          const th = document.createElement('th');
          th.scope = 'row';
          th.textContent = label;
          tr.append(th);
          selected.forEach((card) => {
            const td = document.createElement('td');
            td.textContent = specs(card)[key];
            tr.append(td);
          });
          tbody.append(tr);
        });
        table.append(tbody);
        compareContent.append(table);
        compareQuote.href = '/pages/request-equipment-quote?' + quoteParams(selected).toString();
      };
      const showResults = () => {
        const ranked = cards
          .map((card) => ({ card, score: scoreCard(card) }))
          .filter((item) => item.score > -1000)
          .sort((a, b) => b.score - a.score);

        cards.forEach((card) => {
          card.hidden = true;
          card.style.order = '';
        });

        ranked.slice(0, 3).forEach((item, index) => {
          item.card.hidden = false;
          item.card.style.order = String(index);
          const data = specs(item.card);
          item.card.querySelector('[data-match-card-meta]').textContent = [data.rating, data.format, data.configuration]
            .filter((value) => value && value !== root.dataset.notSpecified)
            .join(' • ');
        });

        advisor.hidden = true;
        results.hidden = false;
        quoteLink.href = '/pages/request-equipment-quote?' + quoteParams([]).toString();
        saveMatch();
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      family.addEventListener('change', () => {
        updateConditionalFields();
        invalidateResults();
        saveMatch();
      });

      familyShortcuts.forEach((button) => {
        button.addEventListener('click', () => {
          family.value = button.dataset.matchFamilyShortcut || '';
          family.dispatchEvent(new Event('change', { bubbles: true }));
          family.focus();
        });
      });

      [demand, power, sheetSize, design, bendLength, material, thickness].forEach((field) => {
        field.addEventListener('change', () => {
          invalidateResults();
          saveMatch();
        });
        field.addEventListener('input', () => {
          invalidateResults();
          saveMatch();
        });
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        showResults();
      });

      form.addEventListener('reset', () => {
        requestAnimationFrame(() => {
          try {
            sessionStorage.removeItem(matchStorage);
          } catch {
          }
          updateConditionalFields();
          results.hidden = true;
          advisor.hidden = false;
          cards.forEach((card) => {
            card.hidden = true;
          });
        });
      });

      cards.forEach((card) => {
        card.querySelector('[data-compare-add]').addEventListener('click', () => {
          if (selected.includes(card)) {
            selected = selected.filter((item) => item !== card);
          } else if (selected.length < 3) {
            selected = [...selected, card];
          } else {
            tray.setAttribute('data-limit-active', 'true');
            names.textContent = root.dataset.limitMessage;
            setTimeout(() => {
              tray.removeAttribute('data-limit-active');
              updateTray();
            }, 2200);
            return;
          }
          updateTray();
        });
      });

      openCompare.addEventListener('click', () => {
        renderComparison();
        dialog.showModal();
      });
      root.querySelector('[data-compare-close]').addEventListener('click', () => dialog.close());
      root.querySelector('[data-compare-clear]').addEventListener('click', () => {
        selected = [];
        updateTray();
        dialog.close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      restoreMatch();
      restoreCompare();

      if (window.location.hash === `#${root.id}`) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(() => {
          root.scrollIntoView({
            block: 'start',
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        }, 350);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"] && !Shopify.designMode) return;
  try {
    
  function initializePremiumProduct(root) {
    if (!root || root.dataset.galleryReady === 'true') return;

    var image = root.querySelector('.gold-product__main-image');
    var buttons = root.querySelectorAll('[data-product-gallery-button]');
    if (!image || !buttons.length) return;

    root.dataset.galleryReady = 'true';
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var nextSource = button.dataset.imageUrl;
        if (!nextSource) return;

        image.style.opacity = '0';
        window.setTimeout(function () {
          image.src = nextSource;
          if (button.dataset.imageSrcset) image.srcset = button.dataset.imageSrcset;
          if (button.dataset.imageSizes) image.sizes = button.dataset.imageSizes;
          image.alt = button.dataset.imageAlt || image.alt;
          image.style.opacity = '1';
        }, 120);

        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  document.querySelectorAll('[data-product-premium]').forEach(initializePremiumProduct);
  document.addEventListener('shopify:section:load', function (event) {
    initializePremiumProduct(event.target.querySelector('[data-product-premium]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-quote-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  class UmproProjectBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-project-form]');
      this.fields = Object.fromEntries(Array.from(this.querySelectorAll('[data-project-field]')).map((field) => [field.dataset.projectField, field]));
      this.machineDetail = this.querySelector('[data-project-machine-detail]');
      this.zip = this.querySelector('[data-project-zip]');
      this.financing = this.querySelector('[data-project-financing]');
      this.groups = Array.from(this.querySelectorAll('[data-project-group]'));
      this.summary = this.querySelector('.project-builder__summary');
      this.progressBar = this.querySelector('[data-project-progress-bar]');
      this.progressText = this.querySelector('[data-project-progress-text]');
      this.readyState = this.querySelector('[data-project-ready-state]');
      this.importStatus = this.querySelector('[data-project-import-status]');
      this.copyStatus = this.querySelector('[data-project-copy-status]');
      this.continueButton = this.querySelector('[data-project-continue]');
      this.imported = {};
      this.transitioning = false;

      this.restore();
      this.form.addEventListener('input', () => this.render(false));
      this.form.addEventListener('change', () => this.render(false));
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.querySelector('[data-project-import]').addEventListener('click', () => this.importMatch());
      this.querySelector('[data-project-copy]').addEventListener('click', () => this.copy());
      this.form.addEventListener('reset', () => window.setTimeout(() => this.reset(), 0));
      this.render(false);
    }

    label(field) {
      if (!(field instanceof HTMLSelectElement) || !field.value) return '';
      return field.selectedOptions[0]?.textContent?.trim() || '';
    }

    groupComplete(group) {
      const key = group.dataset.projectGroup;
      if (key === 'delivery') {
        const delivery = this.fields.delivery?.value || '';
        const needsZip = ['delivery_quote', 'commercial_dock', 'jobsite_review'].includes(delivery);
        this.zip.required = needsZip;
      }
      const required = Array.from(group.querySelectorAll('[required]'));
      return required.every((field) => field.checkValidity());
    }

    update() {
      const machine = this.machineDetail.value.trim() || this.label(this.fields.machine) || this.dataset.emptyValue;
      const powerParts = [this.label(this.fields.shop_power), this.label(this.fields.power_package)].filter(Boolean);
      const deliveryParts = [this.label(this.fields.delivery), this.zip.value.trim() ? `ZIP ${this.zip.value.trim()}` : '', this.label(this.fields.unloading)].filter(Boolean);
      const values = {
        machine,
        power: powerParts.join(' • ') || this.dataset.emptyValue,
        compressor: this.label(this.fields.compressor) || this.dataset.emptyValue,
        delivery: deliveryParts.join(' • ') || this.dataset.emptyValue,
        installation: this.label(this.fields.installation) || this.dataset.emptyValue,
        training: this.label(this.fields.training) || this.dataset.emptyValue
      };
      Object.entries(values).forEach(([key, value]) => {
        const output = this.querySelector(`[data-project-summary="${key}"]`);
        if (output) output.textContent = value;
      });

      const completed = this.groups.filter((group) => {
        const complete = this.groupComplete(group);
        group.dataset.complete = String(complete);
        return complete;
      }).length;
      const percent = Math.round((completed / this.groups.length) * 100);
      this.progressBar.style.width = `${percent}%`;
      this.progressText.textContent = this.dataset.progressTemplate.replace('__CURRENT__', String(completed)).replace('__TOTAL__', String(this.groups.length));
      const ready = completed === this.groups.length;
      this.summary.dataset.ready = String(ready);
      this.readyState.textContent = ready ? this.dataset.readyLabel : this.dataset.draftLabel;
      this.continueButton.dataset.projectUrl = this.projectUrl();
      this.save();
    }

    render(animate) {
      const change = () => this.update();
      if (animate && document.startViewTransition && !this.transitioning && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.transitioning = true;
        const transition = document.startViewTransition(change);
        transition.finished.catch(() => {}).finally(() => { this.transitioning = false; });
      } else {
        change();
      }
    }

    machineMatchContext() {
      const root = document.querySelector('[data-machine-match]');
      if (!root) return {};
      const cards = Array.from(root.querySelectorAll('[data-match-card]'));
      const selected = cards.filter((card) => card.querySelector('[data-compare-add]')?.getAttribute('aria-pressed') === 'true');
      const visible = cards.filter((card) => !card.hidden);
      const chosen = selected.length ? selected : visible.slice(0, 3);
      const familyMap = {
        sheet_laser: 'fiber-laser-cutting-machines',
        press_brake: 'hydraulic-press-brakes',
        laser_welder: 'handheld-laser-welding-machines'
      };
      return {
        family: familyMap[root.querySelector('[data-match-family]')?.value] || '',
        demand: root.querySelector('[data-match-demand]')?.value || '',
        power: root.querySelector('[data-match-power]')?.value || '',
        working_size: root.querySelector('[data-match-family]')?.value === 'press_brake' ? root.querySelector('[data-match-bend-length]')?.value || '' : root.querySelector('[data-match-sheet-size]')?.value || '',
        design: root.querySelector('[data-match-design]')?.value || '',
        application: root.querySelector('[data-match-material]')?.value?.trim() || '',
        capacity: root.querySelector('[data-match-thickness]')?.value?.trim() || '',
        machines: chosen.map((card) => card.dataset.title).filter(Boolean)
      };
    }

    importMatch() {
      const context = this.machineMatchContext();
      if (!context.family && !context.machines?.length) {
        this.importStatus.textContent = this.dataset.importEmpty;
        return;
      }
      this.imported = context;
      if (context.family && Array.from(this.fields.machine.options).some((option) => option.value === context.family)) this.fields.machine.value = context.family;
      if (context.machines?.length) this.machineDetail.value = context.machines.join(' | ');
      if (context.power && Array.from(this.fields.shop_power.options).some((option) => option.value === context.power)) this.fields.shop_power.value = context.power;
      const machineText = context.machines?.join(' • ') || this.label(this.fields.machine);
      this.importStatus.textContent = this.dataset.importedTemplate.replace('__MACHINES__', machineText);
      this.render(true);
    }

    projectUrl() {
      const context = { ...this.machineMatchContext(), ...this.imported };
      const machine = this.machineDetail.value.trim() || this.label(this.fields.machine);
      const params = new URLSearchParams();
      params.set('route', 'machine_quote');
      params.set('source', 'project-builder');
      params.set('source_path', location.pathname);
      params.set('family', this.fields.machine.value);
      const machineChoices = context.machines?.length ? context.machines : machine.split('|').map((value) => value.trim()).filter(Boolean);
      params.set('machine', machineChoices[0] || machine);
      if (machineChoices.length > 1) params.set('comparison', machineChoices.join(' | '));
      if (context.demand) params.set('demand', context.demand);
      if (context.working_size) params.set('working_size', context.working_size);
      if (context.design) params.set('design', context.design);
      if (context.application) params.set('application', context.application);
      if (context.capacity) params.set('capacity', context.capacity);
      params.set('power', this.fields.shop_power.value);
      params.set('project_power', this.label(this.fields.power_package));
      params.set('compressor', this.label(this.fields.compressor));
      params.set('delivery', this.label(this.fields.delivery));
      if (this.zip.value.trim()) params.set('zip', this.zip.value.trim());
      if (this.fields.unloading.value) params.set('unloading', this.label(this.fields.unloading));
      params.set('installation', this.label(this.fields.installation));
      params.set('training', this.label(this.fields.training));
      params.set('financing', this.financing.checked ? 'Include financing review' : 'No financing review requested');
      if (this.fields.timing.value) {
        params.set('timeline', this.fields.timing.value);
        params.set('project_timing', this.fields.timing.value);
      }
      return `${this.dataset.rfqUrl}?${params.toString()}`;
    }

    submit(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      location.href = this.projectUrl();
    }

    summaryText() {
      const lines = Array.from(this.querySelectorAll('.project-builder__summary dl div')).map((row) => {
        const label = row.querySelector('dt')?.textContent?.trim() || '';
        const value = row.querySelector('dd')?.textContent?.trim() || '';
        return `${label}: ${value}`;
      });
      lines.push(this.dataset.pricePrivate);
      return lines.join('\n');
    }

    async copy() {
      const text = this.summaryText();
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          copied = await Promise.race([
            navigator.clipboard.writeText(text).then(() => true),
            new Promise((resolve) => window.setTimeout(() => resolve(false), 700))
          ]);
        }
      } catch {
      }
      if (!copied) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        Object.assign(textarea.style, { position: 'fixed', inset: '-10000px auto auto -10000px' });
        document.body.append(textarea);
        textarea.select();
        try { copied = document.execCommand('copy'); } catch {
        }
        textarea.remove();
      }
      this.copyStatus.textContent = copied ? this.dataset.copySuccess : this.dataset.copyError;
    }

    save() {
      const values = Object.fromEntries(Object.entries(this.fields).map(([key, field]) => [key, field.value]));
      try {
        sessionStorage.setItem(this.dataset.storageKey, JSON.stringify({ values, machine: this.machineDetail.value.trim(), financing: this.financing.checked, expiresAt: Date.now() + 7200000 }));
      } catch {
      }
    }

    restore() {
      try {
        const state = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
        if (!state || Number(state.expiresAt) <= Date.now()) {
          sessionStorage.removeItem(this.dataset.storageKey);
          return;
        }
        Object.entries(state.values || {}).forEach(([key, value]) => {
          const field = this.fields[key];
          if (field && Array.from(field.options).some((option) => option.value === String(value))) field.value = String(value);
        });
        this.machineDetail.value = String(state.machine || '');
        this.financing.checked = Boolean(state.financing);
      } catch {
      }
    }

    reset() {
      this.machineDetail.value = '';
      this.zip.value = '';
      this.imported = {};
      this.importStatus.textContent = '';
      this.copyStatus.textContent = '';
      try { sessionStorage.removeItem(this.dataset.storageKey); } catch {
      }
      this.render(true);
    }
  }

  if (!customElements.get('umpro-project-builder')) customElements.define('umpro-project-builder', UmproProjectBuilder);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-machine-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-smart-bundle-root]:not([data-bundle-ready])').forEach((root) => {
      root.dataset.bundleReady = 'true';
      const storageKey = `umprotech.smartBundle.v1.${root.dataset.machine}`;
      const nativeHost = root.querySelector('[data-bundle-native]');
      const coverage = root.querySelector('[data-bundle-coverage]');
      const progress = root.querySelector('[data-bundle-progress]');
      const count = root.querySelector('[data-bundle-count]');
      const quote = root.querySelector('[data-bundle-quote]');
      const shareButton = root.querySelector('[data-bundle-share]');
      const presetButtons = [...root.querySelectorAll('[data-bundle-preset]')];
      const live = root.querySelector('[data-bundle-live]');
      let savedState = readShared() || readSaved();

      function readSaved() {
        try {
          const parsed = JSON.parse(localStorage.getItem(storageKey));
          if (Array.isArray(parsed)) {
            return { values: parsed, explicitProducts: parsed.some((value) => value.startsWith('product:')) };
          }
          if (Array.isArray(parsed?.values)) return parsed;
          return null;
        } catch {
          return null;
        }
      }

      function readShared() {
        const params = new URLSearchParams(window.location.search);
        if (!params.has('bundle') && !params.has('products')) return null;
        const scopes = (params.get('bundle') || '').split(',').filter((value) => /^[a-z0-9-]+$/i.test(value)).map((value) => `scope:${value}`);
        const products = (params.get('products') || '').split(',').filter((value) => /^[a-z0-9-]+$/i.test(value)).map((value) => `product:${value}`);
        return { values: [...scopes, ...products], explicitProducts: params.has('products') };
      }

      function choices() {
        return [...root.querySelectorAll('[data-bundle-choice]:checked')].map((input) => input.value);
      }

      function applySaved() {
        if (!savedState) return;
        root.querySelectorAll('[data-bundle-choice]').forEach((input) => {
          if (input.value.startsWith('product:') && !savedState.explicitProducts) return;
          input.checked = savedState.values.includes(input.value);
        });
      }

      function writeSaved() {
        savedState = { values: choices(), explicitProducts: root.querySelectorAll('[data-bundle-choice][value^="product:"]').length > 0 };
        try {
          localStorage.setItem(storageKey, JSON.stringify(savedState));
        } catch {
          return;
        }
      }

      function scopeInputs() {
        return [...root.querySelectorAll('[data-bundle-choice][value^="scope:"]')];
      }

      function presetValues(preset) {
        const tiers = preset === 'core' ? ['core'] : preset === 'production' ? ['core', 'production'] : ['core', 'production', 'turnkey'];
        return scopeInputs().filter((input) => tiers.includes(input.dataset.bundleTier)).map((input) => input.value);
      }

      function sameValues(first, second) {
        if (first.length !== second.length) return false;
        const expected = new Set(second);
        return first.every((value) => expected.has(value));
      }

      function activePreset() {
        const selected = choices().filter((value) => value.startsWith('scope:'));
        return ['core', 'production', 'turnkey'].find((preset) => sameValues(selected, presetValues(preset))) || 'custom';
      }

      function announce(message) {
        if (!live) return;
        live.textContent = '';
        window.setTimeout(() => {
          live.textContent = message;
        }, 20);
      }

      function track(eventName, detail = {}) {
        const selected = choices();
        const payload = {
          event: eventName,
          machine: root.dataset.machine,
          package_mode: activePreset(),
          scope_count: selected.filter((value) => value.startsWith('scope:')).length,
          product_count: selected.filter((value) => value.startsWith('product:')).length,
          ...detail
        };
        if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
        document.dispatchEvent(new CustomEvent(`umprotech:${eventName}`, { detail: payload }));
      }

      function update() {
        const selected = choices();
        const selectedScope = selected.filter((value) => value.startsWith('scope:'));
        const selectedProducts = selected.filter((value) => value.startsWith('product:'));
        const totalScope = Math.max(scopeInputs().length, 1);
        const preset = activePreset();
        if (coverage) coverage.textContent = String(selectedScope.length);
        if (progress) progress.style.width = `${Math.min(selectedScope.length / totalScope, 1) * 100}%`;
        if (count) count.textContent = String(selected.length);
        presetButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.bundlePreset === preset));
        });
        if (quote) {
          const params = new URLSearchParams();
          params.set('source', 'smart-bundle');
          params.set('machine', root.dataset.machine);
          params.set('bundle', selectedScope.map((value) => value.slice(6)).join(','));
          params.set('package', preset);
          if (selectedProducts.length) params.set('products', selectedProducts.map((value) => value.slice(8)).join(','));
          quote.href = `/pages/request-equipment-quote?${params.toString()}`;
        }
      }

      root.addEventListener('change', (event) => {
        if (!event.target.matches('[data-bundle-choice]')) return;
        writeSaved();
        update();
        announce(root.dataset.packageUpdated);
        track('smart_bundle_scope_changed', { choice: event.target.value, selected: event.target.checked });
      });

      presetButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = new Set(presetValues(button.dataset.bundlePreset));
          scopeInputs().forEach((input) => {
            input.checked = selected.has(input.value);
          });
          writeSaved();
          update();
          announce(root.dataset.packageUpdated);
          track('smart_bundle_preset_selected', { selected_preset: button.dataset.bundlePreset });
        });
      });

      function packageUrl() {
        const selected = choices();
        const url = new URL(window.location.href);
        url.searchParams.set('bundle', selected.filter((value) => value.startsWith('scope:')).map((value) => value.slice(6)).join(','));
        if (root.querySelectorAll('[data-bundle-choice][value^="product:"]').length) {
          url.searchParams.set('products', selected.filter((value) => value.startsWith('product:')).map((value) => value.slice(8)).join(','));
        } else {
          url.searchParams.delete('products');
        }
        url.searchParams.set('package', activePreset());
        url.searchParams.set('utm_source', 'smart-bundle');
        return url.toString();
      }

      async function sharePackage() {
        const url = packageUrl();
        if (navigator.share) {
          try {
            await navigator.share({ title: root.dataset.shareTitle, url });
            announce(root.dataset.sharedStatus);
            track('smart_bundle_shared');
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }
        try {
          await navigator.clipboard.writeText(url);
        } catch {
          const field = document.createElement('textarea');
          field.value = url;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.append(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }
        announce(root.dataset.sharedStatus);
        track('smart_bundle_shared');
      }

      shareButton?.addEventListener('click', sharePackage);
      quote?.addEventListener('click', () => track('smart_bundle_rfq_started'));

      async function loadComplementary() {
        if (!nativeHost || root.dataset.performed === 'true') return;
        try {
          const response = await fetch(root.dataset.recommendationsUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Recommendations request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = page.querySelector('[data-bundle-native]');
          if (!incoming) throw new Error('Recommendations markup missing');
          nativeHost.innerHTML = incoming.innerHTML;
          root.dataset.performed = 'true';
          applySaved();
          update();
          track('smart_bundle_recommendations_loaded', { recommendation_count: root.querySelectorAll('[data-bundle-product]').length });
        } catch {
          nativeHost.hidden = true;
        }
      }

      window.addEventListener('storage', (event) => {
        if (event.key !== storageKey) return;
        savedState = readSaved();
        applySaved();
        update();
      });

      applySaved();
      update();
      track('smart_bundle_view');
      loadComplementary();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
